import React from "react";
import { Container } from "react-bootstrap";

import NewUser from "../shared/users/NewUser";
const NewStaff = () => {
  return (
    <Container>
      <NewUser redirectTo={"staff"} title={"Employee"} />
    </Container>
  );
};

export default NewStaff;
